import { useState, useEffect } from 'react';
import {
  fetchTrendingTopics,
  fetchTimeSlotActivity,
  fetchUpcomingEvents,
  fetchNetworkingGroups,
  type TrendingTopic,
  type TimeSlotActivity,
  type RealEvent,
  type NetworkingGroup
} from '@/services/networkingAnalyticsService';

export const useNetworkingAnalytics = () => {
  const [trendingTopics, setTrendingTopics] = useState<TrendingTopic[]>([]);
  const [timeSlotActivity, setTimeSlotActivity] = useState<TimeSlotActivity[]>([]);
  const [upcomingEvents, setUpcomingEvents] = useState<RealEvent[]>([]);
  const [networkingGroups, setNetworkingGroups] = useState<NetworkingGroup[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadData = async () => {
    try {
      setLoading(true);
      setError(null);

      const [topics, timeSlots, events, groups] = await Promise.all([
        fetchTrendingTopics(),
        fetchTimeSlotActivity(),
        fetchUpcomingEvents(),
        fetchNetworkingGroups()
      ]);

      setTrendingTopics(topics);
      setTimeSlotActivity(timeSlots);
      setUpcomingEvents(events);
      setNetworkingGroups(groups);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erreur lors du chargement des données');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const refreshData = () => {
    loadData();
  };

  const getAnalyticsStats = () => {
    const totalEvents = upcomingEvents.length;
    const totalGroups = networkingGroups.length;
    const totalMembers = networkingGroups.reduce((sum, group) => sum + group.members, 0);
    const activeTopics = trendingTopics.filter(t => t.trend === 'up').length;

    return {
      totalEvents,
      totalGroups,
      totalMembers,
      activeTopics
    };
  };

  return {
    trendingTopics,
    timeSlotActivity,
    upcomingEvents,
    networkingGroups,
    loading,
    error,
    refreshData,
    getAnalyticsStats
  };
};